import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils';

export const Skeleton = ({ className, ...p }: React.HTMLAttributes<HTMLDivElement>) => (
  <div aria-hidden className={cn('animate-pulse rounded-md bg-muted', className)} {...p} />
);

const alertVariants = cva(
  'relative w-full rounded-lg border px-4 py-3 text-sm flex gap-3 items-start [&_svg]:size-4 [&_svg]:mt-0.5',
  {
    variants: {
      variant: {
        default: 'bg-card',
        info: 'bg-primary/5 border-primary/30',
        atencao: 'bg-warning/15 border-warning/50',
        erro: 'bg-destructive/10 border-destructive/40 text-destructive',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export const Alert = ({
  className,
  variant,
  ...p
}: React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>) => (
  <div role="alert" className={cn(alertVariants({ variant }), className)} {...p} />
);

export const Badge = ({ className, ...p }: React.HTMLAttributes<HTMLSpanElement>) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium',
      className,
    )}
    {...p}
  />
);

/** Estado vazio padrão (toda tela tem carregando, vazio e erro). */
export function EstadoVazio({
  titulo,
  descricao,
  icone,
  acao,
}: {
  titulo: string;
  descricao?: string;
  icone?: React.ReactNode;
  acao?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed p-10 text-center">
      {icone && <div className="text-muted-foreground [&_svg]:size-8">{icone}</div>}
      <p className="font-medium">{titulo}</p>
      {descricao && <p className="max-w-md text-sm text-muted-foreground">{descricao}</p>}
      {acao}
    </div>
  );
}

export function EstadoErro({ mensagem, onTentar }: { mensagem?: string; onTentar?: () => void }) {
  return (
    <Alert variant="erro">
      <div className="flex-1">
        <p className="font-medium">Não conseguimos carregar.</p>
        <p>{mensagem ?? 'Verifique sua internet e tente de novo.'}</p>
      </div>
      {onTentar && (
        <button className="underline" onClick={onTentar} type="button">
          Tentar de novo
        </button>
      )}
    </Alert>
  );
}
